import { Link } from "gatsby"
import Shot, { ImageProps, ShotProps } from "./shot"
import React, { ReactNode } from "react"

type MediaImageSource = ImageProps | string | ReactNode | null

export type MediaItemProps = {
    title: string
    subtitle: string|null
    url?: string
    image: MediaImageSource
    intro?: ReactNode
    key: string|number
}

export type MediaListProps = {
    items: MediaItemProps[]
    textlineCount?: number
}

const RenderMediaImage = (image: MediaImageSource) => {
    if(typeof image == 'string') {
        return <img src={image}/>
    }

    if(React.isValidElement(image))
    {
        return image
    }

    if(typeof image == 'object' && image != null && 'folder' in image)
    {
        return <Shot image={image} keepAspectRatio={true}/>
    }
    
    return null
}

const MediaItem = ({ title, subtitle, url, image, intro } : MediaItemProps) => {
    const titleEl = <h5>{title} <small className="text-muted">{subtitle}</small></h5>
    return <li>
        {image && RenderMediaImage(image)}
        
        <div className="flex-grow-1">
            {url ? <Link to={url} className="stretched-link">{titleEl}</Link> : titleEl}
            <div className="text d-none d-md-block">
            <p>{intro}</p>
            </div>                
        </div>
    </li>
}

export const MediaList = ({ items, textlineCount } : MediaListProps) => {
    textlineCount ??= 3
    return <ul className={`media lines-${textlineCount}`}>
        {items.map(item => <MediaItem {...item} />)}
    </ul>
}

export default MediaList